import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import type { DocumentSectionsResponse } from '../../services/documents/DocumentRepository.ts';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';

export const useGetPreviewGridByContentId = (contentId: string) => {
  const queryKey = ['sectionsMetaData', contentId, 'migration'];

  const hasValidContentId = !!contentId;
  const isEnabled = hasValidContentId;

  const result: UseQueryResult<DocumentSectionsResponse, unknown> = useQuery(
    queryKey,
    async () => {
      return await apiDocumentServiceRepository.getSectionsByContentId(contentId);
    },
    {
      staleTime: Infinity,
      enabled: isEnabled,
    }
  );
  return { status: result.status, data: result.data };
};
